import css from './nrkno-masthead.scss'
import coreToggle from '@nrk/core-toggle'
import {
  nrkLogoNrk,
  nrkLogoNrkTv,
  nrkLogoNrkRadio,
  nrkLogoNrkP3Symbol,
  nrkLogoNrkSuper,
  nrkLogoYr,
  nrkChevronDown,
  nrkUserLoggedin,
  nrkUserNotloggedin,
  nrkSearch,
  nrkClose
} from '@nrk/core-icons'

Masthead.initialize = function () {
  if (typeof document === 'undefined') return
  coreToggle('.nrk-masthead__bars, .nrk-masthead__more', { popup: true })

  const loginLink = document.querySelector('.nrk-masthead__user a')
  if (loginLink) {
    const script = document.createElement('script')
    script.src = '/logginn.js'
    script.async = true
    document.head.appendChild(script)

    // eslint-disable-next-line
    ;(function(c,a){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}})(window, 'onLoginReady')

    window.onLoginReady((user) => {
      if (user) {
        const span = document.createElement('span')
        const canReplaceState = window.history && window.history.replaceState
        const isAutoLogin = window.location.search.indexOf('autoLogin=true') >= 0

        span.textContent = user.name
        loginLink.innerHTML = nrkUserLoggedin
        loginLink.appendChild(span)

        if (isAutoLogin) {
          const banner = document.body.insertAdjacentElement('afterbegin', document.createElement('div'))

          banner.className = 'nrk-masthead__auto-login-banner'
          banner.innerHTML = `<button>${nrkClose}</button><strong>Hei</strong>, du er nå logget inn på nrk.no, fordi du allerede er innlogget et annet sted hos NRK`
          banner.querySelector('button').addEventListener('click', () => banner.parentElement.removeChild(banner))
          banner.querySelector('strong').textContent = `Hei ${user.name}` // Use textContent for security

          if (canReplaceState) {
            const href = window.location.href.replace(/autoLogin=true&?/, '').replace(/[?|&]$/, '')
            window.history.replaceState(window.history.state, document.title, href)
          }
        }
      }
      loginLink.removeAttribute('hidden')
    })
  }
}

Masthead.initialize() // Auto-init for <script> loading

/**
 * Masthead
 * @param {Object} [data]
 * @param {Object} context
 * @returns {string}
 */
export default function Masthead (options) {
  const { dark = false, login = true, search = true, minimal = false } = options || {}
  const style = css ? `<style>${String(css).replace(/\/\*[^!][^*]*\*\//g, '').replace(/\s*(^|[:;,{}]|$)\s*/g, '$1')}</style>` : ''

  return `${style}<header class="nrk-masthead lp_masthead${dark ? ' nrk-masthead--dark' : ''}${minimal ? ' nrk-masthead--minimal' : ''}">
      <a class="nrk-masthead__logo" href="https://www.nrk.no/" aria-label="NRK">${nrkLogoNrk}</a>
      <button class="nrk-masthead__bars" aria-label="Meny" aria-expanded="false">
        <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24">
          <g fill-rule="evenodd">
            <rect width="20" height="2" x="2" y="4" />
            <rect width="20" height="2" x="2" y="11"/>
            <rect width="20" height="2" x="2" y="18"/>
          </g>
        </svg>
      </button>

      <nav class="nrk-masthead__desktop" hidden>
        <div class="nrk-masthead__apps">
          <ul>
            <li><a href="https://tv.nrk.no/" aria-label="NRK TV">${nrkLogoNrkTv}</a></li>
            <li><a href="https://radio.nrk.no/" aria-label="NRK Radio">${nrkLogoNrkRadio}</a></li>
            <li><a href="https://nrksuper.no" aria-label="NRK Super">${nrkLogoNrkSuper}</a></li>
            <li><a href="https://p3.no" aria-label="NRK P3">${nrkLogoNrkP3Symbol}</a></li>
            <li><a href="https://yr.no" aria-label="Yr">${nrkLogoYr}</a></li>
          </ul>
        </div>

        <ul class="nrk-masthead__promo">
          <li><a href="https://www.nrk.no/nyheter/">Nyheter</a></li>
          <li><a href="https://www.nrk.no/sport/">Sport</a></li>
          <li><a href="https://www.nrk.no/kultur/">Kultur</a></li>
          <li><a href="https://www.nrk.no/distrikt/">Distrikt</a></li>
        </ul>
        <button class="nrk-masthead__more" aria-expanded="false" aria-controls="nrk-masthead__mega">
          <span>Mer</span>
          ${nrkChevronDown}
        </button>
        <div class="nrk-masthead__mega" id="nrk-masthead__mega" hidden>
          <div class="nrk-masthead__wrapper">
            <div class="nrk-masthead__sections">
              <div class="nrk-masthead__section">
                <h2>Nyheter</h2>
                <ul>
                  <li><a href="https://www.nrk.no/nyheter/">Nyhetssenter</a></li>
                  <li><a href="https://www.nrk.no/norge/">Norge</a></li>
                  <li><a href="https://www.nrk.no/urix/">Urix</a></li>
                  <li><a href="https://www.nrk.no/kultur/">Kultur</a></li>
                  <li><a href="https://www.nrk.no/livsstil/">Livsstil</a></li>
                  <li><a href="https://www.nrk.no/viten/">Viten</a></li>
                  <li><a href="https://www.nrk.no/dokumentar/">Dokumentar</a></li>
                  <li><a href="https://www.nrk.no/ytring/">Ytring</a></li>
                  <li><a href="https://www.nrk.no/sapmi/">NRK Sápmi</a></li>
                  <li><a href="https://www.nrk.no/kvensk/">NRK Kvensk</a></li>
                </ul>
              </div>
              <div class="nrk-masthead__section nrk-masthead__section--narrow">
                <h2>Sport</h2>
                <ul>
                  <li><a href="https://www.nrk.no/sport/">Sportsnyheter</a></li>
                  <li><a href="https://resultater.nrk.no/">Resultater</a></li>
                  <li><a href="https://www.nrk.no/sport/sendeplan/">Sendeplan</a></li>
                  <li><a href="https://www.nrk.no/sport/videoklipp/">Videoklipp</a></li>
                </ul>
              </div>
              <div class="nrk-masthead__section">
                <h2>Distrikt</h2>
                <ul>
                  <li><a href="https://www.nrk.no/ostlandssendingen/">Akershus</a></li>
                  <li><a href="https://www.nrk.no/sorlandet/">Aust-Agder</a></li>
                  <li><a href="https://www.nrk.no/buskerud/">Buskerud</a></li>
                  <li><a href="https://www.nrk.no/finnmark/">Finnmark</a></li>
                  <li><a href="https://www.nrk.no/ho/">Hedmark</a></li>
                  <li><a href="https://www.nrk.no/hordaland/">Hordaland</a></li>
                  <li><a href="https://www.nrk.no/mr/">M&oslash;re og Romsdal</a></li>
                  <li><a href="https://www.nrk.no/nordland/">Nordland</a></li>
                  <li><a href="https://www.nrk.no/ho/">Oppland</a></li>
                  <li><a href="https://www.nrk.no/ostlandssendingen/">Oslo</a></li>
                  <li><a href="https://www.nrk.no/rogaland/">Rogaland</a></li>
                  <li><a href="https://www.nrk.no/sognogfjordane/">Sogn og Fjordane</a></li>
                  <li><a href="https://www.nrk.no/telemark/">Telemark</a></li>
                  <li><a href="https://www.nrk.no/troms/">Troms</a></li>
                  <li><a href="https://www.nrk.no/trondelag/">Tr&oslash;ndelag</a></li>
                  <li><a href="https://www.nrk.no/sorlandet/">Vest-Agder</a></li>
                  <li><a href="https://www.nrk.no/vestfold/">Vestfold</a></li>
                  <li><a href="https://www.nrk.no/ostfold/">&Oslash;stfold</a></li>
                </ul>
              </div>
              <div class="nrk-masthead__section nrk-masthead__section--narrow">
                <h2>Temasider</h2>
                <ul>
                  <li><a href="https://www.nrk.no/mat/">NRK Mat</a></li>
                  <li><a href="https://www.nrk.no/skole/">NRK Skole</a></li>
                  <li><a href="https://www.nrkbeta.no/">NRK Beta</a></li>
                </ul>
                <h2>Info</h2>
                <ul>
                  <li><a href="https://hjelp.nrk.no/">Hjelp</a></li>
                  <li><a href="https://www.nrk.no/informasjon/">Informasjon</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        ${search ? `<div class="nrk-masthead__search">
          <form class="nrk-masthead__search-form" role="search" action="https://www.nrk.no/sok/">
            <input type="search" name="q" aria-label="S&oslash;k i hele nrk-universet" placeholder="S&oslash;k" autoComplete="off">
            <button type="submit" aria-label="S&oslash;k">${nrkSearch}</button>
          </form>
        </div>` : ''}
      </nav>

      ${login ? `<div class="nrk-masthead__user">
        <a href="https://www.nrk.no/minside/" hidden>
          ${nrkUserNotloggedin}
          <span>Logg inn</span>
        </a>
      </div>` : ''}
  </header>`
}
